import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModalMotivoCancelacion from '../ModalMotivoCancelacion';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';

const BotonCancelarSAT = ({ isActive, datosSellos, emisor, refreshFactura }) => {
    const [showModalMotivo, setShowModalMotivo] = useState(false);
    const [loading, setLoading] = useState(false);
    const { showErrorToast, showSuccessToast } = useToast();
    const { token } = useToken();

    const handleOpenModal = () => setShowModalMotivo(true);
    const handleCloseModal = () => setShowModalMotivo(false);

    const cancelarFacturaSAT = async (motivoCancelacion = '01', uuidSustituto = '') => {
        setLoading(true);
        const uuidConFormato = uuidSustituto 
            ? `${datosSellos.UUID}|${motivoCancelacion}|${uuidSustituto}`
            : `${datosSellos.UUID}|${motivoCancelacion}|`;
        var objDataSend = {
            rfcEmisor: emisor.Rfc,
            uuids: [uuidConFormato]
        };
        try {
            const response = await fetch("/api/Facturas/CancelarFacturaSat", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objDataSend)
            });
            setLoading(false);
            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage);
                    if (data.cancelaciones && data.cancelaciones.length > 0) {
                        data.cancelaciones.forEach(cancelacion => {
                            if (cancelacion.mensaje) {
                                showSuccessToast(`${cancelacion.mensaje}`);
                            }
                        });
                    }
                    if (refreshFactura) await refreshFactura();
                } else {
                    showErrorToast(data.vMessage || "Error al cancelar la factura en el SAT");
                    if (data.cancelaciones && data.cancelaciones.length > 0) {
                        data.cancelaciones.forEach(cancelacion => {
                            if (cancelacion.mensaje) {
                                showErrorToast(`Error: ${cancelacion.mensaje}`);
                            }
                        });
                    }
                }
            } else {
                const errorData = await response.json().catch(() => ({}));
                showErrorToast(errorData.vMessage || `${response.status} ${response.statusText}`);
            }
        } catch (error) {
            setLoading(false);
            showErrorToast('Hubo un problema con la petici�n Fetch: ' + error);
        }
    };

    const handleConfirm = (motivo, uuidSustituto) => {
        setShowModalMotivo(false);
        cancelarFacturaSAT(motivo, uuidSustituto);
    };

    return (
        <>
            <Button
                variant="info"
                onClick={handleOpenModal}
                className="px-4"
                disabled={!isActive}
            >
                <i className="fas fa-file-invoice me-2"></i>
                {isActive ? 'Cancelar SAT' : 'Factura Inactiva'}
            </Button>
            <ModalMotivoCancelacion
                show={showModalMotivo}
                onHide={handleCloseModal}
                onConfirm={handleConfirm}
                loading={loading}
            />
        </>
    );
};

BotonCancelarSAT.propTypes = {
    isActive: PropTypes.bool,
    datosSellos: PropTypes.object.isRequired,
    emisor: PropTypes.object.isRequired,
    refreshFactura: PropTypes.func // para recargar datos tras cancelar
};

export default BotonCancelarSAT;
